import { store } from "..";
const messageinfo = {
  messages: null,
  alerts: null,
  unreadalerts: 0,
  unreadmessages: 0,
  tempmessages: [],
  modaltab: 0,
  messagetab: 0
};

export default function(state = messageinfo, action) {
  var msgstate;
  switch (action.type) {
    case "RealTimeUpdate for message-reducer":
      msgstate = genmessages(
        action.payload.data ? action.payload.data : action.payload
      );
      if (msgstate) {
        return {
          ...state,
          messages: msgstate.tabs,
          alerts: msgstate.alerts,
          unreadalerts: msgstate.alertcount,
          unreadmessages: msgstate.messagecount
        };
      } else {
        if (action.payload.data) {
          action.payload = action.payload.data;
        }
        return {
          ...this.state,
          tempmessages: action.payload
        };
      }

      break;
    case "RealTimeUpdate for myrealtimeinfo":
      msgstate = genmessages(state.tempmessages);

      if (msgstate) {
        return {
          ...state,
          messages: msgstate.tabs,
          alerts: msgstate.alerts,
          unreadalerts: msgstate.alertcount,
          unreadmessages: msgstate.messagecount,
          tempmessages: []
        };
      }
      break;
    case "edfemployees - employees":
      msgstate = genmessages(state.tempmessages);
      let myinfo = store.getState().myinfo.employeeinfo;
      if (msgstate) {
        let msgstate = genmessages(state.tempmessages, myinfo, action.payload);
        return {
          ...state,
          messages: msgstate.tabs,
          alerts: msgstate.alerts,
          unreadalerts: msgstate.alertcount,
          unreadmessages: msgstate.messagecount,
          tempmessages: []
        };
      }

      break;
    case "message activetab":
      return {
        ...state,
        modaltab: action.payload.modaltab,
        messagetab: action.payload.messagetab
      };

      break;
    default:
  }
  return state;
}
const genmessages = Messages => {
  let employees = store.getState().employees.employees;
  let myinfo = store.getState().myinfo.employeeinfo;
  // console.log(myinfo, employees);
  if (employees && myinfo) {
    if (Messages.data) {
      Messages = Messages.data;
    }
    let tabs = [];
    let messagecount = 0;
    let alertcount = 0;
    let alerts = [];
    Messages = Messages.filter(
      msg => msg.toemp === myinfo.empnumber || msg.fromemp === myinfo.empnumber
    );
    Messages.map(msg => {
      var empnumber;
      if (msg.toemp === myinfo.empnumber) {
        empnumber = msg.fromemp;
      } else {
        empnumber = msg.toemp;
      }
      console.log(empnumber);
      if (msg.importance === "M") {
        messagecount += 1 - msg.readind;
        let msgtabindex = tabs.findIndex(tab => tab.empnumber === empnumber);
        // console.log(msgtabindex);
        if (msgtabindex > -1) {
          tabs[msgtabindex].messages = tabs[msgtabindex].messages.concat(msg);
          if (msg.toemp === myinfo.empnumber) {
            tabs[msgtabindex].unreadcount += 1 - msg.readind;
          }
        } else {
          let emp = {};
          if (msg.fromemp === 0) {
            emp = { empnumber: 0, firstname: "LaborWorks" };
          } else {
            emp = employees.find(emp => emp.empnumber === empnumber);
          }

          let newtab = {
            empnumber: emp.empnumber,
            emp,
            unreadcount: msg.toemp === myinfo.empnumber ? 1 - msg.readind : 0,
            messages: [msg]
          };
          tabs = tabs.concat(newtab);
        }
      } else if (msg.importance === "A") {
        alerts = alerts.concat(msg);
        alertcount += 1 - msg.readind;
      }
    });
    return { tabs, messagecount, alertcount, alerts };
  }
};



// WEBPACK FOOTER //
// ./src/reducers/message-reducer.js